import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState = {};

const accountDetails = createSlice({
	name: 'accountDetails',
	initialState,
	reducers: {
		accountDetailsAdded(state, action) {
			// eslint-disable-next-line no-param-reassign
			if (state) {
				return action.payload;
			}
			return state;
		}
	}
});

export const useAccountDetails = () =>
	useSelector((state) => state.accountDetails);

export const { accountDetailsAdded } = accountDetails.actions;

export default accountDetails.reducer;
